import { gql } from '@apollo/client';

export const ADD_MANY_INSTITUTIONS_TO_COHORT = gql`
  mutation AddManyInstitutionsToCohort($input: AddManyInstitutionsToCohortInput!) {
    cohort: addManyInstitutionsToCohort(input: $input) {
      id
    }
  }
`;
